<script lang="ts" setup>
import Column, { SidebarColumnInterface } from '@app/components/parts/sidebar/column.vue';
import Avatar from '@ui/components/avatar.vue';

export interface SidebarLayoutInterface {
    companyPhoto?: string;
    canHomepageFeedback?: boolean;
    profileUrl?: string;
    profilePictureUrl?: string;
    columns?: SidebarColumnInterface[];
}
const props = withDefaults(defineProps<SidebarLayoutInterface>(), {
    companyPhoto: '',
    profileUrl: '',
    profilePictureUrl: '',
    columns: () => {
        return [];
    },
});
</script>
<template>
    <div
        class="xs:grid-cols-[120px,1fr] grid grid-cols-1 place-content-start border-b border-gray-200 font-sans md:grid-cols-[200px,1fr] lg:grid-cols-1 lg:border-b-0"
    >
        <div class="relative flex aspect-square items-center justify-center bg-white">
            <div
                class="before:absolute before:bottom-0 before:left-0 before:hidden before:h-px before:w-full before:bg-gray-100 before:lg:!block"
            >
                <img
                    :src="props.companyPhoto"
                    class="xs:rounded-lg h-full w-full object-cover align-top lg:rounded-none"
                >
            </div>
            <div
                class="xs:-bottom-2 xs:-right-2 xs:translate-y-0 pointer-events-none absolute bottom-0 right-4 translate-y-10 lg:bottom-0 lg:right-4 lg:translate-y-1/2"
            >
                <Avatar
                    :circle="true"
                    :image="props.profilePictureUrl"
                    :href="props.canHomepageFeedback ? null : props.profileUrl"
                    size="xlarge"
                    class="xs:scale-50 pointer-events-auto bg-gray-50 shadow-lg lg:scale-100"
                ></Avatar>
            </div>
        </div>
        <template v-if="props.columns">
            <div class="grid gap-6 py-6">
                <Column
                    v-for="(column, index) in props.columns"
                    :key="index"
                    :column="column"
                    :index="index"
                ></Column>
            </div>
        </template>
    </div>
</template>
